import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { IFormFieldError } from '@libs/models/models';
import { environment } from '@libs/environment';

export enum ToastType {
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  INFO = 'info',
}

export interface ToasterComponentData {
  type: ToastType;
  title: string;
  content: {
    message?: string;
    loggerCode?: string;
    errors?: IFormFieldError[];
  };
  component?: any;
  componentInputs?: any;
}

class ToasterComponent {
  type: ToastType;
  title: string;
  content: { message?: string };
}

@Component({
  selector: 'app-toaster-widget',
  templateUrl: `./templates/${environment.group}/page.html`,
  styleUrls: [`./templates/${environment.group}/style.sass`, './style.sass'],
})
export class ToasterWidgetComponent {
  public imageSettings: { [key: string]: { url: string; width: string; height: string } } = {
    warning: {
      url: '/assets/images/icons/icon-attention.png',
      width: '24px',
      height: '24px',
    },
    success: {
      url: '/assets/images/icons/icon-success.png',
      width: '22px',
      height: '18px',
    },
    info: {
      url: '/assets/images/icons/icon-attention.png',
      width: '24px',
      height: '24px',
    },
    error: {
      url: '/assets/images/icons/icon-expired.png',
      width: '18px',
      height: '18px',
    },
  };

  constructor(
    private snackBarRef: MatSnackBarRef<ToasterComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: ToasterComponentData,
  ) {}

  public get classes(): string {
    return `toaster ${this.data.type}`;
  }

  public close(): void {
    this.snackBarRef.dismiss();
  }
}
